import React from "react";

const ForChefsSection = () => {
  return (
    <section className="section" id="chefs">
      <div className="container">
        <div className="section-header">
          <p className="tag">For professional chocolatiers</p>
          <h2 className="section-title">
            Designed for the demands of premium chocolate work.
          </h2>
          <p className="section-subtitle">
            Calowry is engineered for craft and industrial partners who care about
            crystal structure, snap, melt curve and coating performance as much
            as they care about nutrition.
          </p>
        </div>

        <div className="chef-grid">
          <div className="chef-card">
            <h3>For bean to bar makers</h3>
            <p>
              Pair your original chocolates with Calowry to launch lighter lines
              without diluting the character you work so hard to achieve.
            </p>
          </div>

          <div className="chef-card">
            <h3>For industrial producers</h3>
            <p>
              Use Calowry as a platform for better for you ranges in grocery,
              convenience and food service without re engineering your entire
              plant.
            </p>
          </div>

          <div className="chef-card">
            <h3>For innovation teams</h3>
            <p>
              Partner with Calowry on custom formulations, pilot runs and
              technical validation for new product families.
            </p>
          </div>
        </div>

        <div className="callout">
          <p>
            Calowry is not a consumer brand. It is an ingredient system created
            to sit behind world class chocolate names and help them lead the
            next era of indulgence.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ForChefsSection;
